// Every product needs a real photo (owner, 2026-10-06; API migration 0013). The brand drawing stays
// the thumbnail on cards and lists; the real photo is what the customer product page shows. A
// product without one can't go on sale: a new product is saved hidden and goes on sale when its
// first photo lands (publishOnPhoto). AdminProduct carries needsPhoto / publishOnPhoto.

/** @typedef {{ needsPhoto?: boolean | null; publishOnPhoto?: boolean | null; status?: string }} PhotoFields */

export const PHOTO_REQUIRED = 'Add a photo first. Every product on PopCart shows a real photo.';
export const PUBLISH_ON_PHOTO = 'It goes on sale as soon as you add the photo.';
export const PHOTO_NOTE = 'Customers see this photo on the product page. The drawing stays the thumbnail.';

/** @param {PhotoFields | null | undefined} p */
export function needsPhoto(p) {
  return !!p?.needsPhoto;
}

/**
 * The list/editor badge, or null when the product has its photo.
 * @param {PhotoFields | null | undefined} p
 * @returns {{ label: string; tone: 'warning' } | null}
 */
export function photoBadge(p) {
  return needsPhoto(p) && p?.status !== 'archived' ? { label: 'Needs a photo', tone: 'warning' } : null;
}

/**
 * Why the "On sale" switch can't be turned on, or null when it can. Hiding is always allowed
 * (an older photo-less product still on sale can be hidden; it then waits for its photo).
 * @param {PhotoFields | null | undefined} p
 */
export function visibilityBlock(p) {
  if (!needsPhoto(p) || p?.status === 'active') return null;
  return p?.publishOnPhoto ? PUBLISH_ON_PHOTO : PHOTO_REQUIRED;
}

/** The list's "Needs a photo" chip lives in the URL as ?photo=missing. */
export const PHOTO_PARAM = 'photo';
export const PHOTO_MISSING = 'missing';

/** @param {URLSearchParams} params */
export function readPhotoFilter(params) {
  return params.get(PHOTO_PARAM) === PHOTO_MISSING;
}

/**
 * Client-side filter over the loaded rows (the API list has no photo filter).
 * @template {PhotoFields} T
 * @param {T[]} rows
 * @param {boolean} on
 * @returns {T[]}
 */
export function filterByPhoto(rows, on) {
  return on ? rows.filter(needsPhoto) : rows;
}
